import { ThemeProvider } from "styled-components"

import { Loading } from "./components/atoms"
import { AuthProvider } from "./contexts/Auth/AuthProvider"
import { InterceptorProvider } from "./contexts/Interceptor/InterceptorProvider"
import { NotificationProvider } from "./contexts/NotificationCTX/NotificationProvider"
import { PdfViewerProvider } from "./contexts/PdfViewer/InterceptorProvider"
import { ConsultaTourProvider } from "./contexts/ConsultaTour/ConsultaTourProvider"
import Router from "./routes"
import GlobalStyle from "./styles/global"
import { defaultTheme } from "./styles/themes/defaultTheme"

function App() {
  return (
    <PdfViewerProvider>
      <AuthProvider>
        <ThemeProvider theme={defaultTheme}>
          <NotificationProvider>
            <InterceptorProvider>
              <ConsultaTourProvider>
                <>
                  <GlobalStyle />
                  <Loading active={false} />
                  <Router />
                </>
              </ConsultaTourProvider>
            </InterceptorProvider>
          </NotificationProvider>
        </ThemeProvider>
      </AuthProvider>
    </PdfViewerProvider>
  )
}

export default App
